import React, { useState } from 'react';
import SupportCard from '../../../component/support/SupportCard';
import * as Icons from '../../../public/icons/Supporticons';
import { SearchIcon } from '../../../public/icons';
import { GiftIcon } from '../../../public/icons';

const Support = () => {

  const [searchQuery, setSearchQuery] = useState('');

  const supportCategories = [
    {
      icon: Icons.OrderReceivedIcon,
      title: 'Orders & Delivery',
      description: 'Tracking, shipping, delivery dates, and issues.',
      link: 'orders-delivery',
      categories: ['Shipping', 'Tracking', 'Delivery']
    },
    {
      icon: Icons.FrameworksIcon,
      title: 'Frame it Forward',
      description: 'Gift boxes, add-ons, and future gifts.',
      link: 'frameworks',
      categories: ['Gift Boxes', 'Add-ons', 'Bundles']
    },
    {
      icon: Icons.FutureGiftsIcon,
      title: 'Future Gifts',
      description: 'Everything about preparing, scheduling, and managing future gifts.',
      link: 'future-gifts',
      categories: ['Schedule', 'Manage', 'Update'],
      isFutureGift: true
    },
    {
      icon: Icons.MemoirsIcon,
      title: 'Memoirs',
      description: 'Creating, editing, and printing your memoir.',
      link: 'memoirs',
      categories: ['Create', 'Edit', 'Print']
    },
    {
      icon: Icons.RefundIcon,
      title: 'Payment & Refund',
      description: 'Charges, discounts, refunds, and invoices.',
      link: 'refunds-payments',
      categories: ['Refunds', 'Invoices', 'Payments']
    },
    {
      icon: Icons.TechnicalIssuesIcon,
      title: 'Technical Issues',
      description: 'Uploads, errors, account access.',
      link: 'technical',
      categories: ['Uploads', 'Errors', 'Account']
    },
  ];

  return (
    <div className="min-h-screen pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto text-left">
        {/* Header */}
        <div className="mb-5 sm:mb-6 md:mb-8">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Customer Support
          </h1>
          <p className="text-sm sm:text-base font-normal text-[#6B635D] max-w-3xl">
            We're here to help you create, gift, and preserve meaningful memories every step of the way.
          </p>
        </div>

        {/* Search Bar */}
        <div className="relative mb-6 sm:mb-8 md:mb-9">
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <SearchIcon size={20} />
          </div>
          <input
            type="text"
            placeholder="Search orders, future gifts, memoirs, delivery, or payments"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="p-2.5 sm:p-3 pl-10 sm:pl-12 pr-3 w-full border placeholder:text-[#6B635D] placeholder:text-xs sm:placeholder:text-sm placeholder:font-light border-[#DBDBDB] bg-transparent focus:outline-none focus:ring-2 focus:ring-[#D4A574] focus:border-transparent rounded"
          />
        </div>

        {/* Support Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
          {supportCategories.map((category, index) => (
            <SupportCard key={index} {...category} />
          ))}
        </div>

        {/* Contact Support Section */}
        <div className="mt-8 sm:mt-12 md:mt-0">
          <div className="flex flex-col items-center text-center lg:text-left lg:flex-row lg:items-center justify-between gap-6 sm:gap-8">
            <div className="lg:flex-1">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1C2A46] mb-3 sm:mb-4">
                Need Support?
              </h2>
              <p className="text-base sm:text-lg text-[#6B635D] mb-4 sm:mb-6">
                Can't find the answer you're looking for, don't worry we're here to help!
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a
                  href="mailto:support@kapta.com"
                  className="inline-flex items-center justify-center px-5 sm:px-6 py-2.5 sm:py-3 bg-[#D2A146] text-white font-medium hover:bg-[#C19564] transition-colors duration-200 text-sm sm:text-base"
                >
                  Contact support
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;